// Which sites Needed from Amazon lists: Site details' top sites, or, for InRange alone, every
// Amazon site (Noaa, 25 Oct 2026). Someone outside InRange, or InRange in View as, always
// gets the top sites, whatever the URL says.
import { useContext } from "react";
import { useSearchParams } from "react-router-dom";

import { UserContext } from "../../auth";
import { TOP } from "./BuildingView";

export const SITES_PARAM = "sites";
export const EVERY_SITE = "all";

export const useEverySite = (): boolean => {
  const { role } = useContext(UserContext);
  const [params] = useSearchParams();
  return role === "admin" && params.get(SITES_PARAM) === EVERY_SITE;
};

export const sitesListed = <T>(shown: T[], everySite: boolean): T[] =>
  everySite ? shown : shown.slice(0, TOP);
